interface HostDisplaySource {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

interface GetHostDisplayDataParams {
  host?: HostDisplaySource | null;
  kioskEnteredHostName?: string | null;
}

const normalizeText = (value?: string | null) => value?.trim() || '';

export const getHostDisplayData = ({ host, kioskEnteredHostName }: GetHostDisplayDataParams) => {
  const fallbackName = normalizeText(kioskEnteredHostName) || 'N/A';
  const firstName = normalizeText(host?.firstName);
  const lastName = normalizeText(host?.lastName);
  const email = normalizeText(host?.email);

  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
  const hostName = fullName || fallbackName;
  const fallbackInitials = fallbackName
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part.charAt(0).toUpperCase())
    .join(' ');
  const fallbackAvatarText = fallbackName === 'N/A' ? fallbackName : (fallbackInitials || 'N/A');
  const hostAvatarText =
    [firstName.charAt(0), lastName.charAt(0)].filter(Boolean).join(' ') ||
    fallbackAvatarText;
  const hostTooltip = email ? `${hostName} - ${email}` : hostName;

  return {
    hostName,
    hostAvatarText,
    hostTooltip,
    hostEmail: email,
  };
};
